module.exports = __webpack_public_path__ + "img/dabiao_0001_2.65af3f6f.png";